let ModalGallery = require('./../ModalGallery');

let carAccessories = false;
let modalGallery = false;

class AccessoriesGallery  {

    static init(accessories, i18n) {
        return new AccessoriesGallery(accessories, i18n);
    }

    constructor (data,
        i18n = {
        addItem:'Add',
        removeItem: 'Remove'
    }) {
        const self = this;
        this.i18n = i18n;
        this.data = data;
        this.$sliders = $('.gallery-accessories .slider');
        this.initSliders();
        this.initModalGallery();
        this.initEvents();

        if(!carAccessories) {

            carAccessories = $('.CarAccessories')
                .on('click', '.item-container', this.onClickItemSlider)
                .on('click', '.zoom-btn', function (e) {
                    e.preventDefault();
                    self.modalGallery.show($(this), e);
                })
                .on('click', '.accessories-bar a', this.onClickMenuOption);
            //$('.exterior .zoom-btn:eq(0)').click();

        }

        $('.accessories-bar a:eq(1)').click();
    }

    renderBtns($div, data) {
        if($(`#accessory_${data.id}>.item`).is('.selected')) {
            $div.find('.addItem').hide();
            $div.find('.removeItem').show().addClass('btn-text-fadeIn');
        } else {
            $div.find('.removeItem').hide();
            $div.find('.addItem').show().addClass('btn-text-fadeIn');
        }
    }

    renderDescription (data) {
        var price = (typeof data.price != 'undefined') ? '$' + data.price : '';

        const $div = $(`
            <div class="description-accessory">
                <div class="description-box">
                    <div class="title">${data.description}</div>
                    <div class="price">${price}</div>
                </div>
                <div class="call-action-box">
                    <a href="//localhost:3000/car/crv/gallery" class="BtnStd BtnStd-primary addItem">
                        <span> ${this.i18n.addItem}</span><span class="iArrow"><i class="aLight"></i></span>
                    </a>
                    <a href="//localhost:3000/car/crv/gallery" class="BtnStd BtnStd-primary removeItem">
                        <span> ${this.i18n.removeItem}</span><span class="iArrow"><i class="aLight"></i></span>
                    </a>
                </div>
            </div>
        `).data('item', data);
        this.renderBtns($div, data);
        return $div;
    }

    initModalGallery () {

        if(!modalGallery) {
            modalGallery = this.modalGallery = new ModalGallery({
                className: 'modal-accessories',
                rootElement: 'body',
                data: this.data,
                filterItems: ($element, data) => this.filterItems($element, data),
                renderDescription : (data) => this.renderDescription(data)
            });

        } else {
            this.modalGallery = modalGallery;
            modalGallery.setData(this.data);
        }

    }

    initSliders() {
        this.$sliders.slick({
            slidesToShow: 4,
            slidesToScroll: 3,
            dots: true,
            arrows: false,
            infinite:false,
            touchMove:false,
            responsive: [
                {
                  breakpoint: 829,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                  }
                },{
                    breakpoint: 500,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                    }
                  }
            ]
          });
    }

    initEvents() {
        this.modalGallery.getModalJQ()
            .on('click', '.description-accessory .addItem', e => this.onClickAddRemoveItemModalBtn(e))
            .on('click', '.removeItem', e => this.onClickAddRemoveItemModalBtn(e) );

        $(window).resize(e => {
            this.$sliders.slick('setPosition');
        })
    }

    filterItems ($element, data) {
        const category = $element.closest('.slider').data('category');
        return data[category];
    }

    onClickAddRemoveItemModalBtn(event) {
        event.preventDefault();
        const $div =  $(event.target).closest('.description-accessory');
        const data = $div.data('item');
        $(`#accessory_${data.id}>.item`).click();
        this.renderBtns($div, data);
    }

    onClickItemSlider (e){
        $(e.target).toggleClass('selected');
        e.preventDefault();
    }

    onClickMenuOption (e) {
        let $a = $(e.target);
        e.preventDefault();

        if($a.is('.current')) {

            return ;

        } else {

            let gallery = $a.data('gallery');
            let $current = $('.accessories-bar a.current')
            $current.removeClass('current');
            $a.addClass('current');

            if($current.length) {
                let galleryOut = $(`.${$current.data('gallery')}`);
                if(galleryOut.length >= 1) {

                    galleryOut.fadeOut('slow', e => {
                        $(`.${gallery}`).fadeIn();
                        $(`.${gallery}`).slick('setPosition');
                    });

                } else {
                    $(`.${gallery}`).fadeIn();
                    $(`.${gallery}`).slick('setPosition');
                }

            } else {

                $a.addClass('current');
                $(`.${gallery}`).fadeIn();
                $(`.${gallery}`).slick('setPosition');

            }

        }
    }

}

module.exports = AccessoriesGallery;
